import {
  FETCH_MAIN_RINGS,
  FETCH_HOLDER_RINGS,
  FETCH_RING_SHADOWS,
  SELECT_ACTIVE_MAIN_RING,
  SELECT_ACTIVE_HOLDER_RINGS,
} from "../actions/types";

const INITIAL_STATE = {
  activeMainRing: null,
  activeHolderRings: null,
  mainRings: null,
  holderRings: null,
  ringShadows: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MAIN_RINGS:
      return { ...state, mainRings: action.payload };
    case FETCH_HOLDER_RINGS:
      return { ...state, holderRings: action.payload };
    case FETCH_RING_SHADOWS:
      return { ...state, ringShadows: action.payload };
    case SELECT_ACTIVE_MAIN_RING:
      return { ...state, activeMainRing: action.payload };
    case SELECT_ACTIVE_HOLDER_RINGS:
      return { ...state, activeHolderRings: action.payload };
    default:
      return state;
  }
};
